type SuggestedValue = string;
interface AutofillSuggestions {
	[paramKey: string]: SuggestedValue[];
}

export type SelectedNodeState = {
	[key: string]: unknown;
	autofillSuggestions: AutofillSuggestions;
	isAutofillLoading: boolean;
	autofillError: unknown;
};

export const initialState = (): SelectedNodeState => ({
	editNode: {},
	loadingExtraFields: false,
	editNodeParams: [],
	editNodeParamsId: null,
	needExtraFields: false,
	sideBarState: 'closed',
	getExtraFieldsPromise: null,
	isFlowTreeDragging: false,
	forceLoadDynamicFields: false,
	isNodeDataLoading: false,
	testingProfile: false,
	tempEditNodeCopy: null,
	afterUpdateEditNodeHandlers: [],
	nodeAttributesToUpdate: [],
	autofillSuggestions: {},
	isAutofillLoading: false,
	autofillError: null,
});

const state = initialState();

export default state;
